export function cloneFixture<T>(value: T): T {
  return structuredClone(value);
}
